import { render, staticRenderFns } from "./Lances.vue?vue&type=template&id=6bb9833c&"
import script from "./Lances.vue?vue&type=script&lang=js&"
export * from "./Lances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports